import React, { useState } from "react";

function DoBQuestion(props) {
  const [inputs, setInputs] = useState({});
  const getDefaultDob = (item) => {
    let defaultValue = props.defaultDOB === undefined ? "" : props.defaultDOB;

    if (defaultValue === "") return defaultValue;
    return defaultValue[item];
  };
  const handleValue = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    const iType = event.target.type;
    if (isNaN(value.trim())) {
      event.target.value = "";
    } else {
      //console.log(`N:${name} V: ${value} Type: ${iType}`);
      setInputs((values) => ({
        ...values,
        [name]: { val: value, valType: iType },
      }));
      props.handleValue(event);
    }
  };

  function getAge() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    var DOBdd = 0;
    var DOBmm = 0;
    var DOByyyy = 0;

    if (inputs.DOB_Month && inputs.DOB_Day && inputs.DOB_Year) {
      DOBdd = inputs.DOB_Day.val;
      DOBmm = inputs.DOB_Month.val;
      DOByyyy = inputs.DOB_Year.val;
    } else {
      return "";
    }
    var ageThisYear = yyyy - DOByyyy - 1;
    if (DOBmm < mm) {
      ageThisYear += 1;
    } else {
      if (DOBmm === mm) {
        if (DOBdd <= dd) {
          ageThisYear += 1;
        }
      }
    }
    return `Age ${ageThisYear}`;
  }

  return (
    <li id="DoB_li">
      <label className="description" htmlFor="DOB">
        Date of Birth
      </label>
      <span>
        <input
          id="DOB_Month"
          name="DOB_Month"
          className="element text"
          size="2"
          maxLength="2"
          type="text"
          defaultValue={getDefaultDob("mm")}
          onBlur={(event) => {
            handleValue(event);
          }}
          required
        />
        /<label htmlFor="DOB_Month">MM</label>
      </span>
      <span>
        <input
          id="DOB_Day"
          name="DOB_Day"
          className="element text"
          defaultValue={getDefaultDob("dd")}
          size="2"
          maxLength="2"
          type="text"
          onBlur={(event) => {
            handleValue(event);
          }}
          required
        />
        /<label htmlFor="DOB_Day">DD</label>
      </span>
      <span>
        <input
          id="DOB_Year"
          name="DOB_Year"
          className="element text"
          size="4"
          maxLength="4"
          type="text"
          onBlur={(event) => {
            handleValue(event);
          }}
          defaultValue={getDefaultDob("yyyy")}
          required
        />
        <label htmlFor="DOB_Year">YYYY</label>
      </span>
      <span>{getAge()}</span>
    </li>
  );
}

export default DoBQuestion;
